import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-astmechanicalengineering',
  templateUrl: './astmechanicalengineering.component.html',
  styleUrls: ['./astmechanicalengineering.component.scss']
})
export class AstmechanicalengineeringComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
